module.exports = __webpack_public_path__ + "toGroom-we-r-n.335652c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-r-n.jpg
// module id = Sn+y
// module chunks = 0